import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';
import { DateTime } from 'luxon';

import Content from './ContentBox';
import CalendarPicker from './CalendarPicker';
import ClickOutside from 'app/src/elements/ClickListener';
import { dateRange } from './dateHelpers';

import {
  MarketOption,
  MarketOptionsContainer,
  OptionText
} from './selectElements';

const DateRangeSelect = ({ startOn, setStartOn, endOn, setEndOn }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [calendarStartOn, setCalendarStartOn] = useState(startOn);
  const [calendarEndOn, setCalendarEndOn] = useState(endOn);

  const today = DateTime.now().toISODate();

  const options = [
    {
      label: 'Month to Date',
      startOn: DateTime.now().startOf('month').toISODate(),
      endOn: today,
    },
    {
      label: 'Quarter to Date',
      startOn: DateTime.now().startOf('quarter').toISODate(),
      endOn: today,
    },
    {
      label: 'Year to Date',
      startOn: DateTime.now().startOf('year').toISODate(),
      endOn: today,
    },
  ];

  const selectedOption = options.find(option => (
    option.startOn === startOn && option.endOn === endOn
  ));

  const handleSelect = selected => {
    setStartOn(selected.startOn);
    setEndOn(selected.endOn);
    setShowOptions(false);
  };

  const handleCalendarClose = value => {
    if (value) { return; }

    if (calendarStartOn && calendarEndOn) {
      setStartOn(calendarStartOn);
      setEndOn(calendarEndOn);
      setShowOptions(false);
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <Pressable onPress={() => setShowOptions(true)}>
        <Content.ValueBox highlight={startOn !== endOn}>
          <Content.Value color={startOn !== endOn ? 'white' : null}>
            {selectedOption ?
              selectedOption?.label :
              (startOn !== endOn ? dateRange(startOn, endOn) : 'Date Range')
            }
          </Content.Value>
        </Content.ValueBox>
      </Pressable>

      {showOptions && (
        <ClickOutside onClick={() => setShowOptions(false)}>
          <MarketOptionsContainer>
            {options.map(option => {
              const selected =
                option.startOn === startOn && option.endOn === endOn;

              return (
                <MarketOption
                  key={option.label}
                  onPress={() => handleSelect(option)}
                  selected={selected}
                >
                  <OptionText selected={selected}>{option.label}</OptionText>
                </MarketOption>
              );
            })}

            <MarketOption>
              <CalendarPicker
                startOn={calendarStartOn}
                setStartOn={setCalendarStartOn}
                endOn={calendarEndOn}
                setEndOn={setCalendarEndOn}
                setActive={handleCalendarClose}
                multiDay
              />
            </MarketOption>
          </MarketOptionsContainer>
        </ClickOutside>
      )}
    </View>
  );
};

export default DateRangeSelect;
